/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import * as actionsOlerite from '../../store/olerite/actions';
import * as selectorsOlerite from '../../store/olerite/reducer';
import * as selectorsAuth from '../../store/auth/reducer';
import { Input, DialogDefault, DatePicker } from '../../components';
import moment from 'moment';
import UsuarioContainer from './UsuarioContainer';

const createSchema = {
  mesReferencia: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  usuarios: { presence: { allowEmpty: false, message: 'é obrigatório (mínimo 1 usuário)' } },
};

const useStyles = makeStyles(() => ({
  gridContainer: {
    marginTop: 0
  },
  fieldContainer: {
    paddingBottom: '0px !important'
  }
}));

const Formulario = ({
  createOlerite,
  oleriteClearSelected,
  open,
  onClose,
  authData,
}) => {
  const classes = useStyles();

  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  const getDefaultValues = () => ({
    criadoPorId: authData.id,
    criadoPorNome: authData.nome,
    mesReferencia: moment().format('YYYY-MM'),
    arquivos: [],
  });

  useEffect(() => {
    if (open) {
      setValues(getDefaultValues());
    }
  }, [open]);

  const onSave = () => {
    const erros = validate(values, createSchema);
    setErrors(erros || {});
    if (!erros) {
      createOlerite(values, saveCallback);
    }
  };

  const saveCallback = (success) => {
    if (success) {
      onCloseLocal(true);
    }
  };

  const onCloseLocal = (isSave) => {
    oleriteClearSelected();
    setErrors({});
    setValues(getDefaultValues());
    onClose(isSave);
  };

  return (
    <DialogDefault
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Olerite"
      confirmMessage="Salvar"
      contentClassName={classes.contentClassName}
      maxWidth="md"
    >
      <Grid container spacing={3} className={classes.gridContainer}>
        <Grid item xs={4} className={classes.fieldContainer}>
          <DatePicker
            label="Mês Referência"
            yearMonth
            showInput
            isRequired
            error={errors && errors.mesReferencia}
            onChange={(data) => setValues({ ...values, mesReferencia: data ? moment(data).format('YYYY-MM') : null })}
            value={values.mesReferencia ? moment(values.mesReferencia, 'YYYY-MM').valueOf() : null}
          />
        </Grid>
        <Grid item xs={4} className={classes.fieldContainer}>
          <Input
            label="Criado Por"
            value={values.criadoPorNome}
            disabled
          />
        </Grid>
        <UsuarioContainer
          usuarios={values.usuarios}
          onSave={usuarios => setValues({ ...values, usuarios })}
          showError={errors && errors.usuarios}
        />
      </Grid>
    </DialogDefault>
  );
};

const mapStateToProps = (state) => ({
  selectedOlerite: selectorsOlerite.getSelectedOlerite(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actionsOlerite,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
